import SearchInput from "../../../components/SearchInput/SearchInput";

const HPLogsHeader = ({ tab, searchQuery, onSearchChange, searchPlaceholder, onTabChange }) => (
  <div className="logs_header">
    <div className="logs_header_left">
      <SearchInput
        className="logs_search_bar"
        name="searchQuery"
        placeholder={searchPlaceholder}
        value={searchQuery}
        onChange={onSearchChange}
      />
    </div>

    <div className="logs_header_right">
      <div className="subToggle">
        <button
          type="button"
          className={`subToggle__btn ${tab === "users" ? "is-active" : ""}`}
          onClick={() => onTabChange("users")}
        >
          Users List
        </button>
        <button
          type="button"
          className={`subToggle__btn ${tab === "devices" ? "is-active" : ""}`}
          onClick={() => onTabChange("devices")}
        >
          Devices List
        </button>
      </div>
    </div>
  </div>
);

export default HPLogsHeader;
